import { Component, OnInit, Injector, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataStateChangeEvent, GridComponent } from '@progress/kendo-angular-grid';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';

@Component({
  selector: 'app-orders-notes-list',
  templateUrl: './orders-notes-list.component.html',
  styleUrls: ['./orders-notes-list.component.scss']
})
export class OrdersNotesListComponent extends AppComponentBase implements OnInit {

  @ViewChild('grid', { static: true }) private grid: GridComponent;

  orderId: string;
  gridItems: any;

  constructor(
    injector: Injector,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.queryParams.quoteId) {
      this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
    } else if (this.activatedRoute.snapshot.queryParams.jobId) {
      this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
    }
    this.onRefreshGridData();
  }

  onRefreshGridData(): void {
    this.kendogridHelper.sort = [{ dir: 'desc', field: 'createdDate' }];
    this.grid.dataStateChange.emit({
      skip: 0,
      take: 5,
      filter: undefined,
      group: undefined,
      sort: this.kendogridHelper.sort,
    });
  }

  getGridRecords(event: DataStateChangeEvent): void {
    if (event) {
      this.kendogridHelper.dataStateChangeEvent(event);
    }
    this.kendogridHelper.showLoadingIndicator();
    const queryParams = `OrderId=${this.orderId}`;
    this.commonService.gerOrderNotes(queryParams)
    .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe((response: any) => {
      if (response.isSuccess) {
        this.gridItems = response.data;
        this.kendogridHelper.setGridData(this.gridItems);
      } else {
        this.toastr.error(response.errors || 'Something Went wrong, Please Re-try.', 'Error!');
      }
      this.kendogridHelper.hideLoadingIndicator();
    });
  }

}
